import React, { Component } from 'react';
import { connect } from 'react-redux';
import DeparturesComponent from './DeparturesComponent';

class Departures extends Component {
  render() {
    const { departures, language } = this.props;

    if (!departures) {
      return null;
    }

    const _departures = departures.length > 0 && departures.slice(0, 2);
    const hasMoreDepartures = departures.length > 0 && departures.length - 2;

    return <DeparturesComponent departures={_departures} hasMoreDepartures={hasMoreDepartures} language={language} />;
  }
}

function mapStateToProps(state) {
  return {
    language: state.settings.value.locale.language,
  };
}

export default connect(mapStateToProps)(Departures);
